import { Modal, StyleSheet, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import IconButton from "../../../components/ButtonIcon";
import * as Colors from "../../../styles/colors";

export default function Options({ modalVisible,
    setModalVisible,
    idContract,
    navigation }) {

    const onPressVehicles = () => {
        setModalVisible(!modalVisible)
        navigation.navigate("VehiclesList", {
            idContract: idContract,
        })} 

    const onPressCredential = () => {
        setModalVisible(!modalVisible)
        navigation.navigate("CredentialList", {
            idContract: idContract,
        }) 
    }

    const onPressBilling = () => {
        setModalVisible(!modalVisible)
        navigation.navigate("BillingList", {
            idContract: idContract,
        })
    }

    return <Modal
        animationType="fade"
        transparent={true}
        style={{ backgroundColor: "#000" }}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(!modalVisible)}
    >
        <View style={styles.centeredView}>
            <View style={styles.modalView}>
                <Icon
                    name="close"
                    size={32}
                    onPress={() => {
                        setModalVisible(!modalVisible);
                    }}
                    style={styles.closeButton}
                />
                <IconButton
                    textoBotao={"Veículos"}
                    iconName={"car"}
                    estilo={{
                        backgroundColor: Colors.INFO,
                        width: 256,
                        marginVertical: 8
                    }} 
                    onPress={() => onPressVehicles()}
                    />
                <IconButton
                    textoBotao={"Credenciais"}
                    iconName={"card-bulleted"}
                    estilo={{
                        backgroundColor: Colors.WARNING,
                        width: 256,
                        marginBottom: 8
                    }} 
                    onPress={() => onPressCredential()}/>
                <IconButton textoBotao={"Cobranças"}
                    iconName={"currency-usd"}
                    estilo={{
                        backgroundColor: Colors.SUCCESS,
                        width: 256,
                    }} 
                    onPress={() => onPressBilling()}
                    />
            </View>
        </View>
    </Modal>
}

const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0,0,0,0.5)",
    },
    closeButton: {
        marginLeft: "auto",
        color: Colors.GRAY_DARK,
    },
    modalView: {
        margin: 20,
        backgroundColor: Colors.WHITE,
        borderRadius: 8,
        padding: 16,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
})